"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function RectangleSmMobileSvg(t0) {
  const $ = _c(183);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        const t2 = `${id}-bright-blue`;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[4] = t2;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = `url(#${id}-bright-blue)`;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#5375CF" />;
          $[6] = t6;
        } else {
          t6 = $[6];
        }
        let t7;
        if ($[7] !== style) {
          t7 = <motion.path opacity={0.4} d="M390 330H196V232.988C196 179.411 239.436 136 292.988 136C346.539 136 390 179.436 390 232.988V330Z" fill="#4668C2" style={style("bottom right")} />;
          $[7] = style;
          $[8] = t7;
        } else {
          t7 = $[8];
        }
        let t8;
        if ($[9] !== style) {
          t8 = <motion.path opacity={0.7} d="M99 -32.5L293 -32.5L293 64.5125C293 118.089 249.564 161.5 196.012 161.5C142.461 161.5 99 118.064 99 64.5125L99 -32.5Z" fill="#4668C2" style={style("top center")} />;
          $[9] = style;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== t5 || $[12] !== t7 || $[13] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[11] = t5;
          $[12] = t7;
          $[13] = t8;
          $[14] = t9;
        } else {
          t9 = $[14];
        }
        let t10;
        if ($[15] !== t4 || $[16] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[15] = t4;
          $[16] = t9;
          $[17] = t10;
        } else {
          t10 = $[17];
        }
        return t10;
      }
    case "light-green":
      {
        const t2 = `${id}-light-green`;
        let t3;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[19] = t2;
          $[20] = t4;
        } else {
          t4 = $[20];
        }
        const t5 = `url(#${id}-light-green)`;
        let t6;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#9BD7D2" />;
          $[21] = t6;
        } else {
          t6 = $[21];
        }
        let t7;
        if ($[22] !== style) {
          t7 = <motion.path opacity={0.7} d="M570 300H271V150.481C271 67.9064 337.945 1 420.481 1C503.017 1 570 67.9449 570 150.481V300Z" fill="#85CDC7" style={style("bottom right")} />;
          $[22] = style;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        let t8;
        if ($[24] !== style) {
          t8 = <motion.path opacity={0.7} d="M-28 1L271 1.00003L271 150.519C271 233.094 204.055 300 121.519 300C38.9834 300 -28 233.055 -28 150.519L-28 1Z" fill="#85CDC7" style={style("center left")} />;
          $[24] = style;
          $[25] = t8;
        } else {
          t8 = $[25];
        }
        let t9;
        if ($[26] !== t5 || $[27] !== t7 || $[28] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[26] = t5;
          $[27] = t7;
          $[28] = t8;
          $[29] = t9;
        } else {
          t9 = $[29];
        }
        let t10;
        if ($[30] !== t4 || $[31] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[30] = t4;
          $[31] = t9;
          $[32] = t10;
        } else {
          t10 = $[32];
        }
        return t10;
      }
    case "turquoise":
      {
        const t2 = `${id}-turquoise`;
        let t3;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[33] = t3;
        } else {
          t3 = $[33];
        }
        let t4;
        if ($[34] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[34] = t2;
          $[35] = t4;
        } else {
          t4 = $[35];
        }
        const t5 = `url(#${id}-turquoise)`;
        let t6;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#00968C" />;
          $[36] = t6;
        } else {
          t6 = $[36];
        }
        let t7;
        if ($[37] !== style) {
          t7 = <motion.rect opacity={0.65} width="300" height="300" rx="16.4482" fill="#00A399" style={style("center left")} />;
          $[37] = style;
          $[38] = t7;
        } else {
          t7 = $[38];
        }
        let t8;
        if ($[39] !== style) {
          t8 = <motion.circle cx="450" cy="150" r="150" fill="#00A399" style={style("center right")} />;
          $[39] = style;
          $[40] = t8;
        } else {
          t8 = $[40];
        }
        let t9;
        if ($[41] !== t5 || $[42] !== t7 || $[43] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[41] = t5;
          $[42] = t7;
          $[43] = t8;
          $[44] = t9;
        } else {
          t9 = $[44];
        }
        let t10;
        if ($[45] !== t4 || $[46] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[45] = t4;
          $[46] = t9;
          $[47] = t10;
        } else {
          t10 = $[47];
        }
        return t10;
      }
    case "peach":
      {
        const t2 = `${id}-peach`;
        let t3;
        if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[48] = t3;
        } else {
          t3 = $[48];
        }
        let t4;
        if ($[49] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[49] = t2;
          $[50] = t4;
        } else {
          t4 = $[50];
        }
        const t5 = `url(#${id}-peach)`;
        let t6;
        if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#FFB497" />;
          $[51] = t6;
        } else {
          t6 = $[51];
        }
        let t7;
        if ($[52] !== style) {
          t7 = <motion.path opacity={0.7} d="M164.685 294.002H1.85687e-05V129.338C-0.03771 58.4551 57.4229 1.00195 128.315 1.00195H293V165.666C293 236.549 235.539 294.002 164.647 294.002" fill="#FFAF8F" style={style("center left")} />;
          $[52] = style;
          $[53] = t7;
        } else {
          t7 = $[53];
        }
        let t8;
        if ($[54] !== style) {
          t8 = <motion.path opacity={0.7} d="M458.123 300.002H294V135.338C293.962 64.4551 351.227 7.00195 421.877 7.00195H586V171.666C586 242.549 528.736 300.002 458.085 300.002" fill="#F8A98A" style={style("center right")} />;
          $[54] = style;
          $[55] = t8;
        } else {
          t8 = $[55];
        }
        let t9;
        if ($[56] !== t5 || $[57] !== t7 || $[58] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[56] = t5;
          $[57] = t7;
          $[58] = t8;
          $[59] = t9;
        } else {
          t9 = $[59];
        }
        let t10;
        if ($[60] !== t4 || $[61] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[60] = t4;
          $[61] = t9;
          $[62] = t10;
        } else {
          t10 = $[62];
        }
        return t10;
      }
    case "avocado":
      {
        const t2 = `${id}-avocado`;
        let t3;
        if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[63] = t3;
        } else {
          t3 = $[63];
        }
        let t4;
        if ($[64] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[64] = t2;
          $[65] = t4;
        } else {
          t4 = $[65];
        }
        const t5 = `url(#${id}-avocado)`;
        let t6;
        if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#CCE88A" />;
          $[66] = t6;
        } else {
          t6 = $[66];
        }
        let t7;
        if ($[67] !== style) {
          t7 = <motion.path d="M394.405 -21L224.405 149.5L394.405 320L564.405 149.5L394.405 -21Z" fill="#C2E079" style={style("center right")} />;
          $[67] = style;
          $[68] = t7;
        } else {
          t7 = $[68];
        }
        let t8;
        if ($[69] !== style) {
          t8 = <motion.path d="M241 -21L71 149.5L241 320L411 149.5L241 -21Z" fill="#C6E57D" style={style("center left")} />;
          $[69] = style;
          $[70] = t8;
        } else {
          t8 = $[70];
        }
        let t9;
        if ($[71] !== t5 || $[72] !== t7 || $[73] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[71] = t5;
          $[72] = t7;
          $[73] = t8;
          $[74] = t9;
        } else {
          t9 = $[74];
        }
        let t10;
        if ($[75] !== t4 || $[76] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[75] = t4;
          $[76] = t9;
          $[77] = t10;
        } else {
          t10 = $[77];
        }
        return t10;
      }
    case "sky-blue":
      {
        const t2 = `${id}-sky-blue`;
        let t3;
        if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[78] = t3;
        } else {
          t3 = $[78];
        }
        let t4;
        if ($[79] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[79] = t2;
          $[80] = t4;
        } else {
          t4 = $[80];
        }
        const t5 = `url(#${id}-sky-blue)`;
        let t6;
        if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#A6B9F1" />;
          $[81] = t6;
        } else {
          t6 = $[81];
        }
        let t7;
        if ($[82] !== style) {
          t7 = <motion.path d="M165.247 294H1.86321e-05V128.774C-0.0378387 57.6493 57.6189 0 128.753 0H294V165.226C294 236.351 236.343 294 165.209 294" fill="#9BB1EF" style={style("center left")} />;
          $[82] = style;
          $[83] = t7;
        } else {
          t7 = $[83];
        }
        let t8;
        if ($[84] !== style) {
          t8 = <motion.path d="M459.247 300H294V134.774C293.962 63.6493 351.619 6 422.753 6H588V171.226C588 242.351 530.343 300 459.209 300" fill="#90A7E7" style={style("center right")} />;
          $[84] = style;
          $[85] = t8;
        } else {
          t8 = $[85];
        }
        let t9;
        if ($[86] !== t5 || $[87] !== t7 || $[88] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[86] = t5;
          $[87] = t7;
          $[88] = t8;
          $[89] = t9;
        } else {
          t9 = $[89];
        }
        let t10;
        if ($[90] !== t4 || $[91] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[90] = t4;
          $[91] = t9;
          $[92] = t10;
        } else {
          t10 = $[92];
        }
        return t10;
      }
    case "orange":
      {
        const t2 = `${id}-orange`;
        let t3;
        if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[93] = t3;
        } else {
          t3 = $[93];
        }
        let t4;
        if ($[94] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[94] = t2;
          $[95] = t4;
        } else {
          t4 = $[95];
        }
        const t5 = `url(#${id}-orange)`;
        let t6;
        if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#F0B464" />;
          $[96] = t6;
        } else {
          t6 = $[96];
        }
        let t7;
        if ($[97] !== style) {
          t7 = <motion.path d="M410 358.25H189V247.736C189 186.703 238.481 137.25 299.486 137.25C360.491 137.25 410 186.731 410 247.736V358.25Z" fill="#EFAC53" style={style("bottom right")} />;
          $[97] = style;
          $[98] = t7;
        } else {
          t7 = $[98];
        }
        let t8;
        if ($[99] !== style) {
          t8 = <motion.path d="M79 -57.75L300 -57.75L300 52.7642C300 113.797 250.519 163.25 189.514 163.25C128.509 163.25 79 113.769 79 52.7642L79 -57.75Z" fill="#EFAC53" style={style("top left")} />;
          $[99] = style;
          $[100] = t8;
        } else {
          t8 = $[100];
        }
        let t9;
        if ($[101] !== t5 || $[102] !== t7 || $[103] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[101] = t5;
          $[102] = t7;
          $[103] = t8;
          $[104] = t9;
        } else {
          t9 = $[104];
        }
        let t10;
        if ($[105] !== t4 || $[106] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[105] = t4;
          $[106] = t9;
          $[107] = t10;
        } else {
          t10 = $[107];
        }
        return t10;
      }
    case "sea":
      {
        const t2 = `${id}-sea`;
        let t3;
        if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[108] = t3;
        } else {
          t3 = $[108];
        }
        let t4;
        if ($[109] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[109] = t2;
          $[110] = t4;
        } else {
          t4 = $[110];
        }
        const t5 = `url(#${id}-sea)`;
        let t6;
        if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#007190" />;
          $[111] = t6;
        } else {
          t6 = $[111];
        }
        let t7;
        if ($[112] !== style) {
          t7 = <motion.path d="M572 301H271V150.481C271 67.3539 338.393 0 421.481 0C504.569 0 572 67.3927 572 150.481V301Z" fill="#008AAA" style={style("top right")} />;
          $[112] = style;
          $[113] = t7;
        } else {
          t7 = $[113];
        }
        let t8;
        if ($[114] !== style) {
          t8 = <motion.path d="M-30 4.20332e-06L271 3.05176e-05L271 150.519C271 233.646 203.607 301 120.519 301C37.4314 301 -30.0001 233.607 -30 150.519L-30 4.20332e-06Z" fill="#008AAA" style={style("center left")} />;
          $[114] = style;
          $[115] = t8;
        } else {
          t8 = $[115];
        }
        let t9;
        if ($[116] !== t5 || $[117] !== t7 || $[118] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[116] = t5;
          $[117] = t7;
          $[118] = t8;
          $[119] = t9;
        } else {
          t9 = $[119];
        }
        let t10;
        if ($[120] !== t4 || $[121] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[120] = t4;
          $[121] = t9;
          $[122] = t10;
        } else {
          t10 = $[122];
        }
        return t10;
      }
    case "mint":
      {
        const t2 = `${id}-mint`;
        let t3;
        if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[123] = t3;
        } else {
          t3 = $[123];
        }
        let t4;
        if ($[124] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[124] = t2;
          $[125] = t4;
        } else {
          t4 = $[125];
        }
        const t5 = `url(#${id}-mint)`;
        let t6;
        if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#86CD9F" />;
          $[126] = t6;
        } else {
          t6 = $[126];
        }
        let t7;
        if ($[127] !== style) {
          t7 = <motion.path d="M150.868 304H-20V133.154C-20.0391 59.6101 39.5787 0 113.132 0H284V170.846C284 244.39 224.382 304 150.829 304" fill="#77C793" style={style("center left")} />;
          $[127] = style;
          $[128] = t7;
        } else {
          t7 = $[128];
        }
        let t8;
        if ($[129] !== style) {
          t8 = <motion.path d="M454.868 310H284V139.154C283.961 65.6101 343.579 6 417.132 6H588V176.846C588 250.39 528.382 310 454.829 310" fill="#77C793" style={style("center right")} />;
          $[129] = style;
          $[130] = t8;
        } else {
          t8 = $[130];
        }
        let t9;
        if ($[131] !== t5 || $[132] !== t7 || $[133] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[131] = t5;
          $[132] = t7;
          $[133] = t8;
          $[134] = t9;
        } else {
          t9 = $[134];
        }
        let t10;
        if ($[135] !== t4 || $[136] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[135] = t4;
          $[136] = t9;
          $[137] = t10;
        } else {
          t10 = $[137];
        }
        return t10;
      }
    case "yellow":
      {
        const t2 = `${id}-yellow`;
        let t3;
        if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[138] = t3;
        } else {
          t3 = $[138];
        }
        let t4;
        if ($[139] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[139] = t2;
          $[140] = t4;
        } else {
          t4 = $[140];
        }
        const t5 = `url(#${id}-yellow)`;
        let t6;
        if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#FFD152" />;
          $[141] = t6;
        } else {
          t6 = $[141];
        }
        let t7;
        if ($[142] !== style) {
          t7 = <motion.path d="M412 -6L245 161L412 328L579 161L412 -6Z" fill="#FFCC3D" style={style("center right")} />;
          $[142] = style;
          $[143] = t7;
        } else {
          t7 = $[143];
        }
        let t8;
        if ($[144] !== style) {
          t8 = <motion.path d="M214 -6L47 161L214 328L381 161L214 -6Z" fill="#FFCC3D" style={style("center left")} />;
          $[144] = style;
          $[145] = t8;
        } else {
          t8 = $[145];
        }
        let t9;
        if ($[146] !== t5 || $[147] !== t7 || $[148] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[146] = t5;
          $[147] = t7;
          $[148] = t8;
          $[149] = t9;
        } else {
          t9 = $[149];
        }
        let t10;
        if ($[150] !== t4 || $[151] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[150] = t4;
          $[151] = t9;
          $[152] = t10;
        } else {
          t10 = $[152];
        }
        return t10;
      }
    case "cobalt":
      {
        const t2 = `${id}-cobalt`;
        let t3;
        if ($[153] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[153] = t3;
        } else {
          t3 = $[153];
        }
        let t4;
        if ($[154] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[154] = t2;
          $[155] = t4;
        } else {
          t4 = $[155];
        }
        const t5 = `url(#${id}-cobalt)`;
        let t6;
        if ($[156] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#2B52B8" />;
          $[156] = t6;
        } else {
          t6 = $[156];
        }
        let t7;
        if ($[157] !== style) {
          t7 = <motion.path opacity={0.4} d="M390 357H169V246.986C169 186.229 218.481 137 279.486 137C340.491 137 390 186.257 390 246.986V357Z" fill="#2F5FD6" style={style("bottom right")} />;
          $[157] = style;
          $[158] = t7;
        } else {
          t7 = $[158];
        }
        let t8;
        if ($[159] !== style) {
          t8 = <motion.path opacity={0.7} d="M59 -58L280 -58L280 52.0142C280 112.771 230.519 162 169.514 162C108.509 162 59 112.743 59 52.0142L59 -58Z" fill="#2F5FD6" style={style("top left")} />;
          $[159] = style;
          $[160] = t8;
        } else {
          t8 = $[160];
        }
        let t9;
        if ($[161] !== t5 || $[162] !== t7 || $[163] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[161] = t5;
          $[162] = t7;
          $[163] = t8;
          $[164] = t9;
        } else {
          t9 = $[164];
        }
        let t10;
        if ($[165] !== t4 || $[166] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[165] = t4;
          $[166] = t9;
          $[167] = t10;
        } else {
          t10 = $[167];
        }
        return t10;
      }
    case "ocean":
      {
        const t2 = `${id}-ocean`;
        let t3;
        if ($[168] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="300" fill="white" />;
          $[168] = t3;
        } else {
          t3 = $[168];
        }
        let t4;
        if ($[169] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[169] = t2;
          $[170] = t4;
        } else {
          t4 = $[170];
        }
        const t5 = `url(#${id}-ocean)`;
        let t6;
        if ($[171] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="300" fill="#1A3C82" />;
          $[171] = t6;
        } else {
          t6 = $[171];
        }
        let t7;
        if ($[172] !== style) {
          t7 = <motion.rect opacity={0.65} width="300" height="300" rx="16.4482" fill="#3254A2" style={style("center left")} />;
          $[172] = style;
          $[173] = t7;
        } else {
          t7 = $[173];
        }
        let t8;
        if ($[174] !== style) {
          t8 = <motion.circle cx="450" cy="150" r="150" fill="#3254A2" style={style("center right")} />;
          $[174] = style;
          $[175] = t8;
        } else {
          t8 = $[175];
        }
        let t9;
        if ($[176] !== t5 || $[177] !== t7 || $[178] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[176] = t5;
          $[177] = t7;
          $[178] = t8;
          $[179] = t9;
        } else {
          t9 = $[179];
        }
        let t10;
        if ($[180] !== t4 || $[181] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 300" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[180] = t4;
          $[181] = t9;
          $[182] = t10;
        } else {
          t10 = $[182];
        }
        return t10;
      }
    default:
      {
        return null;
      }
  }
}
const RectangleSmMobileColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-[13/10]";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <RectangleSmMobileSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
RectangleSmMobileColorBlock.displayName = "RectangleSmMobileColorBlock";
export { RectangleSmMobileColorBlock };